import React, { useCallback, useMemo, useState } from "react";
import ScoreStar from "../ScoreStar";
import style from "./index.module.scss";
import ModalInfo from "../ModalInfo";
import ScoreStarDetail from "../ScoreStarDetail";

interface Props {
  scoreInfo: {
    comprScore: number; // 综合评分
    efficiencyScore: number; // 维保效率评分
    svcScore: number; // 服务接待评分
    qualityScore: number; // 维保质量评分
  };
}

const ScoreLine = ({ scoreInfo }: Props) => {
  const [visible, setVisible] = useState(false);
  const hideModal = useCallback(() => {
    setVisible(false);
  }, []);
  const detailList = useMemo(() => {
    return [
      { name: "维保效率", score: scoreInfo?.efficiencyScore },
      { name: "维保质量", score: scoreInfo?.qualityScore },
      { name: "服务接待", score: scoreInfo?.svcScore },
    ];
  }, [scoreInfo]);

  return (
    <>
      <div className={style.scoreLineComp}>
        <ScoreStar score={scoreInfo?.comprScore} />
        <span
          className={style.rightPart}
          onClick={(e) => {
            e.stopPropagation();
            setVisible(true);
          }}
        >
          更多评分
          <span className={style.rightArrowIcon} />
        </span>
      </div>
      {visible && (
        <ModalInfo showModal={visible} onHide={hideModal} title="门店评分">
          <div className={style.scoreLineCompModalScore}>
            <ScoreStarDetail
              totalScore={scoreInfo?.comprScore}
              detailList={detailList}
            />
          </div>
        </ModalInfo>
      )}
    </>
  );
};

export default ScoreLine;
